import React, { useEffect, useState } from 'react';
import { PaymentStatusDataForm } from '../../../../app/models/PaymentStatus';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { momentParseDate } from '../../../../helpers';
import { Society } from '../../../../app/models/Society';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { DispatchProgram } from '../../../../app/models/DispatchProgram';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';

type Props = {
    paymentStatus: PaymentStatusDataForm;
    setPaymentStatus: (PaymentStatus: PaymentStatusDataForm) => void;
    societies: Society[];
    clients: Client[];
    dispatchPrograms: DispatchProgram[];
    errorFields?: any;
};

const SecondPaymentStatusForm = ({ 
    paymentStatus, 
    setPaymentStatus, 
    errorFields, 
    societies, 
    clients,
    dispatchPrograms 
}: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    const [selectedDispatch, setSelectedDispatch] = useState<any>(null);
    const [addedDispatchs, setAddedDispatchs] = useState<any[]>([]);

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    useEffect(() => {

        const dispatchsIds = addedDispatchs.map(dispatch => dispatch.id);

        setPaymentStatus({
            ...paymentStatus,
            dispatch_programs_id: dispatchsIds
        });
    }, [addedDispatchs]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setPaymentStatus({ ...paymentStatus, [name]: value });
    };

    const handleChangeSelectTwo = (
        name: string, value: any
    ) => {
        setPaymentStatus({ ...paymentStatus, [name]: value });
    };

    const handleSelectChange = (name: string, value: any) => {

        const selected = dispatchPrograms.find((dispatchs) => dispatchs.id === value.value);
        setSelectedDispatch(selected || null);
    };

    const addDispatch = () => {
        if (selectedDispatch && !addedDispatchs.some(p => p.id === selectedDispatch.id)) {
            setAddedDispatchs([...addedDispatchs, selectedDispatch]);
        }
    };

    const removeDispatch = (id: number) => {
        const updatedDispatchs = addedDispatchs.filter(payment => payment.id !== id);
        setAddedDispatchs(updatedDispatchs);
    };

    


    return (
        <>
        <div className="tax-document-form">

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Sociedad</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="society_id"
                        id="society_id"
                        inputValue={paymentStatus.society_id}
                        options={SelectTwoMapperOptions(societies)}
                        hasError={fieldHasError('society_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('society_id', value.value)}
                        placeholder={'Seleccione una sociedad'}
                        onFocus={() => onFocusRemove('society_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('society_id')}
                    </div>
                </div>
            </div>


            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Cliente</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="client_id"
                        id="client_id"
                        inputValue={paymentStatus.client_id}
                        options={SelectTwoMapperOptions(clients)}
                        hasError={fieldHasError('client_id') !== ''}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('client_id', value.value)
                        }
                        placeholder={'Seleccione un cliente'}
                        onFocus={() => onFocusRemove('client_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('client_id')}
                    </div>
                </div>
            </div>


            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Fecha de emisión</label>
                <div className="col-md-9">
                    <input
                        type="date"
                        className="form-control"
                        id="issue_date"
                        name="issue_date"
                        value={paymentStatus.issue_date}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('issue_date')}
                        // disabled={disabled}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('issue_date')}
                    </div>
                </div>
            </div>



                            <>
            <label className="col-md-6 col-form-label">Despachos</label>
                    <div className="d-flex mb-3 align-items-stretch">
                        <div className="flex-grow-1 me-2">
                            <SelectTwo
                                name="dispatch_program_id"
                                id="dispatch_program_id"
                                inputValue={selectedDispatch ? selectedDispatch.id : null}
                                hasError={fieldHasError('dispatch_programs_id') !== ''}
                                options={SelectTwoMapperOptions(dispatchPrograms, 'id', ['name'])}
                                onChange={(value: any) => handleSelectChange('dispatch_program_id', value)}
                                onFocus={() => onFocusRemove('dispatch_programs_id')}
                                placeholder="Seleccionar Despacho"
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('dispatch_programs_id')}
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={addDispatch}
                            disabled={!selectedDispatch}
                        >
                            Agregar Despacho
                        </button>
                    </div>
                </>

                <div className="table-form">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Nro Despacho</th>
                                {/* <th>Cliente</th> */}
                                <th>Condición de pago</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {addedDispatchs.map((dispatch) => {

                        console.log(dispatch)
                            return(
                                <tr key={dispatch.id}>
                                    <td data-label="Nro">#{dispatch.id}</td>
                                    {/* <td data-label="Cliente">{payment.client_name}</td> */}
                                    <td data-label="Condición de pago">{dispatch.payment_condition}</td>
                                    <td data-label="Acciones">
                                        <ButtonTableAction
                                            callbackFunction={() => removeDispatch(dispatch.id ?? -1)}
                                            classIcon={'mdi mdi-delete'}
                                            colorIcon={'text-danger'}
                                            errorMessage={'No se puede eliminar este registro.'}
                                            title={'Eliminar'}
                                        />
                                    </td>
                                </tr>
                            )
                            }
                                                           )}
                        </tbody>
                    </table>
                </div>



        </div>
         
          
        </>
    );
};

export default SecondPaymentStatusForm;
